import type {Endpoints} from "@hosttools/web/server/routes/routes.users-staff.types";
import {useContext, useMemo} from "react";

import {Base} from "../../../services/base";
import {HTTPContext} from "../../contexts";

export const useStaffUserService = () => {
    const http = useContext(HTTPContext);
    const base = useMemo(() => new Base<Endpoints>(http), [http]);
    return base;
};
